import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import "../styles/Services.css";
import ManifestoImage from "../img/WEB MANIFIESTO.webp";

const translations = {
  ES: {
    aboutTitle: "Sobre nosotros",
    aboutText: [
      "<strong>Grup Empordà Creatiu</strong> nace de la fascinación por un territorio, de su paisaje, de sus vinos, de la gastronomía y de las historias que se esconden entre viñas, pueblos y fogones.",
      "Somos <strong>amantes del papel</strong> y de la manera cómo da forma y permanencia a todo aquello que merece la pena ser contado. Por eso producimos publicaciones con alma, cuidadas hasta el último detalle, donde el diseño y el contenido van de la mano.",
      "Con la misma sensibilidad, <strong>diseñamos eventos únicos</strong>: experiencias que conectan personas, sabores e ideas. No hacemos eventos porque sí.",
      "No venimos a repetir fórmulas. Somos el puente entre lo que pasa y lo que perdura. Entre lo directo y lo tangible.",
      "<strong>Somos territorio en movimiento.</strong><br><strong>Somos cultura hecha experiencia.</strong><br><strong>Somos creatividad en papel.</strong><br><strong>Somos Grup Empordà Creatiu.</strong>",
    ],
    services: [
      {
        title: "Editorial",
        icon: "full_coverage",
        description:
          "Nos dedicamos a la creación de revistas, catálogos, dossiers y otros materiales gráficos y editoriales de alta calidad, adaptando la identidad y necesidades de comunicación de cada empresa a un diseño atractivo e impactante.\n\nTrabajamos ofreciendo soluciones creativas para el sector turístico, bodegas, hoteles, restaurantes y ayuntamientos. Así, cada proyecto se convierte en una herramienta eficaz de comunicación y promoción.",
      },
      {
        title: "Eventos",
        icon: "local_activity",
        description:
          "Producimos eventos y festivales gastronómicos y culturales que capturan la esencia de cada región.\n\nNuestro enfoque se basa en la creatividad, la identidad local y una puesta en escena cuidadosamente diseñada. Nos especializamos en la producción integral, desde la conceptualización hasta la ejecución, asegurando que cada detalle contribuya a una experiencia única y auténtica.",
      },
    ],
  },
  CAT: {
    aboutTitle: "Sobre nosaltres",
    aboutText: [
      "<strong>Grup Empordà Creatiu</strong> neix de la fascinació per un territori, pel seu paisatge, pels seus vins, per la gastronomia i per les històries que s’amaguen entre vinyes, pobles i fogons.",
      "Som <strong>amants del paper</strong> i de la manera com dona forma i permanència a tot allò que val la pena ser explicat. Per això produïm publicacions amb ànima, cuidades fins a l’últim detall, on el disseny i el contingut van de la mà.",
      "Amb la mateixa sensibilitat, <strong>dissenyem esdeveniments únics</strong>: experiències que connecten persones, sabors i idees. No fem esdeveniments perquè sí.",
      "No venim a repetir fórmules. Som el pont entre el que passa i el que perdura. Entre el directe i el tangible.",
      "<strong>Som territori en moviment.</strong><br><strong>Som cultura feta experiència.</strong><br><strong>Som creativitat en paper.</strong><br><strong>Som Grup Empordà Creatiu.</strong>",
    ],
    services: [
      {
        title: "Editorial",
        icon: "full_coverage",
        description:
          "Ens dediquem a la creació de revistes, catàlegs, dossiers i altres materials gràfics i editorials d'alta qualitat, adaptant la identitat i necessitats de comunicació de cada empresa a un disseny atractiu i impactant.\n\nTreballem oferint solucions creatives per al sector turístic, cellers, hotels, restaurants i ajuntaments. Així, cada projecte es converteix en una eina eficaç de comunicació i promoció.",
      },
      {
        title: "Esdeveniments",
        icon: "local_activity",
        description:
          "Produïm esdeveniments i festivals gastronòmics i culturals que capturen l'essència de cada regió.\n\nEl nostre enfoc es basa en la creativitat, la identitat local i una posada en escena acuradament dissenyada. Ens especialitzem en la producció integral, des de la conceptualització fins a l'execució, assegurant que cada detall contribueixi a una experiència única i autèntica.",
      },
    ],
  },
};

const Services = () => {
  const { language } = useLanguage();
  const content = translations[language] || translations.ES;
  const { aboutTitle, aboutText, services } = content;

  const imageRef = useRef(null);
  const [imageVisible, setImageVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setImageVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    if (imageRef.current) {
      observer.observe(imageRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <section id="servicios" className="services">
      <section id="sobre-nosotros" className="about">
        <h2>{aboutTitle}</h2>
        <div className="about-content">
          <div className="about-text">
            {aboutText.map((paragraph, index) => (
              <p key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />
            ))}
          </div>
          <div
            className={`about-image ${imageVisible ? "slide-in" : ""}`}
            ref={imageRef}
          >
            <img src={ManifestoImage} alt="Manifiesto Grup Empordà Creatiu" />
          </div>
        </div>
      </section>

      <div className="services-container">
        {services.map((service, index) => (
          <div key={index} className="service">
            <div className="service-top">
              <div className="service-icon">
                <span className="material-symbols-outlined">
                  {service.icon}
                </span>
              </div>
            </div>
            <h3>{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
